import { db, functions } from '.';
const dailyChallengesRef = db.collection('dailyChallenges');

async function getDailyChallengeFromFormId(formId) {
  const querySnap = await dailyChallengesRef
    .where('typeformId', '==', formId)
    .get();
  if (querySnap.empty) {
    return null;
  } else {
    return querySnap.docs[0];
  }
}

async function add(data) {
  const newFlowRef = dailyChallengesRef.doc();
  if (await getDailyChallengeFromFormId(data.typeformId)) {
    throw Error('There is already a Daily Challenge with that typeform!');
  } else {
    await newFlowRef.set(data);
  }
  return newFlowRef;
}

/**
 * @param {String} formId - Typeform Id
 */
async function getTypeformInfo(formId) {
  const typeformGetInfoCall = functions.httpsCallable('typeformGetInfo');
  const response = await typeformGetInfoCall({ formId });
  if (response['data']['code']) {
    throw response['data']['description'];
  } else {
    return response['data'];
  }
}

export default {
  add,
  getTypeformInfo
};
